// Central site configuration — edit business details, hours, and links here.
// Real business photos live in /public/images. Birthday & Reading Tree photos
// are still stock placeholders — swap them when real photos are available.
export const SITE = {
  name: "Ms. Jeanette's Shaved Ice Snowballs",
  shortName: "Ms. Jeanette's",
  motto: "Come for the snowballs. Stay for the memories.",
  owner: "Jeanette Fontenot Vitrano",
  phone: "228-235-0314",
  phoneHref: "tel:+12282350314",
  email: "jeante54@yahoo.com",
  emailHref: "mailto:jeante54@yahoo.com",
  address: "2501 Hwy 43 S, Picayune, MS 39466",
  mapsUrl: "https://www.google.com/maps/search/?api=1&query=30.519164,-89.639156",
  mapsEmbed: "https://www.google.com/maps?q=30.519164,-89.639156&z=16&output=embed",
  established: "June 25, 2026",
  // Add the verified Facebook page URL here when available, e.g. "https://facebook.com/..."
  facebook: "https://www.facebook.com/share/1HiRfogpqf/?mibextid=wwXIfr",
  hours: [
    { days: "Monday – Thursday", time: "Closed" },
    { days: "Friday – Sunday", time: "2:30 PM – 5:30 PM" },
  ],
  party: {
    price: 225,
    deposit: 50,
    balance: 175,
    maxKids: 15,
    length: "2-hour party",
    includes: [
      "Small snowball for each child",
      "Dedicated party area",
      "Reading Tree",
      "Birthday photo area",
      "Happy Birthday yard-card display",
    ],
  },
};

const img = (base, w = 1200) => `${base}&w=${w}&auto=format&fit=crop`;

export const IMAGES = {
  menu: {
    url: "/images/menu.jpg",
    alt: "Ms. Jeanette's hand-drawn menu board listing snowball flavors, specials, and toppings",
  },
  stand: {
    url: "/images/stand.jpg",
    alt: "The little green polka-dot Ms. Jeanette's Shaved Ice stand with its menu board",
  },
  rainbow: {
    url: "/images/rainbow.jpg",
    alt: "Two colorful rainbow shaved ice snowballs in cups on the grass",
  },
  chantilly: {
    url: "/images/chantilly.jpg",
    alt: "Specialty snowball topped with whipped cream, strawberries, and blueberries",
  },
  drizzle: {
    url: "/images/drizzle.jpg",
    alt: "Stuffed specialty snowball drizzled with chocolate and cookie crumbles",
  },
  stuffed: {
    url: "/images/stuffed.jpg",
    alt: "Stuffed specialty snowball with whipped cream and cookie pieces",
  },
  birthday: {
    url: img("https://images.unsplash.com/photo-1765947378538-86584af05397?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwzfHxjaGlsZHJlbiUyMGJpcnRoZGF5JTIwcGFydHklMjBzdW1tZXIlMjBvdXRkb29yc3xlbnwwfHx8fDE3ODYzMDYxOTh8MA&ixlib=rb-4.1.0&q=85"),
    alt: "Child wearing a party crown at an outdoor summer birthday celebration",
  },
  readingTree: {
    url: img("https://images.unsplash.com/photo-1530083100317-1b635da9af95?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxjaGlsZHJlbiUyMHJlYWRpbmclMjB1bmRlciUyMHRyZWV8ZW58MHx8fHwxNzg2MzA2MTk4fDA&ixlib=rb-4.1.0&q=85"),
    alt: "Children sitting and reading together beneath a tree",
  },
  memories: {
    url: img("https://images.unsplash.com/photo-1762250451705-0460d0c00ac0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxjaGlsZHJlbiUyMGJpcnRoZGF5JTIwcGFydHklMjBzdW1tZXIlMjBvdXRkb29yc3xlbnwwfHx8fDE3ODYzMDYxOTh8MA&ixlib=rb-4.1.0&q=85"),
    alt: "Young girl with arms raised having fun in a sunny park",
  },
};

export const GALLERY = [
  { ...IMAGES.stand, caption: "The little green stand" },
  { ...IMAGES.rainbow, caption: "Rainbow snowballs" },
  { ...IMAGES.chantilly, caption: "Berry-topped specialty" },
  { ...IMAGES.drizzle, caption: "Stuffed specialty snowball" },
  { ...IMAGES.stuffed, caption: "Made with love" },
  { ...IMAGES.birthday, caption: "Birthday celebrations" },
  { ...IMAGES.readingTree, caption: "The Reading Tree" },
];

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/treats", label: "Menu — Snowballs & Treats" },
  { to: "/birthday-parties", label: "Birthday Parties" },
  { to: "/reading-tree", label: "Reading Tree" },
  { to: "/gallery", label: "Gallery" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];
